export const ReplySkeleton = () => (
  <div className="mb-3 flex animate-pulse gap-2">
    <div className="size-8 shrink-0 self-end rounded-full bg-[#E6E6E6]" />
    <div className="h-16 min-w-0 flex-1 rounded-[24px] bg-[#F3F3F6]" />
  </div>
);
